<template>
<div id="pageDashboard">
    <v-container grid-list-xl fluid>
        <v-dialog v-model="deleteModal" persistent max-width="290">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Delete </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="deleteModal=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    Are you sure you want to delete this ?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" small @click="deleteModal=false">
                        No
                    </v-btn>
                    <v-btn color="orange " class="white-text" small @click="deleteAvatar">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog style="overflow-y:visible" v-model="selectNewAvatarModal" persistent max-width="600">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Select New Image</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="selectNewAvatarModal=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-flex lg12 md12 customImgWrap>
                        <div class="customImg bgGray">
                            <v-icon>fa fa-upload</v-icon>
                            <br>
                            Click here to Upload file 
                            <br/>
                            <span class="link-text">
                                <strong>
                                    {{fileObj[0] ? fileObj[0].name : ''}}
                                </strong>
                            </span>
                        </div>                                
                        <input type="file" id="fileField" class="custom-file-input inputfilebutton" @change="onFileChange($event.target.files)">
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray white--text" small @click="selectNewAvatarModal=false">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-toolbar card color="white">
            <v-toolbar-title>
                <h3>
                    MAX AVATAR
                    <!--<v-dialog v-model="maxAvatarInfoDialog" persistent max-width="500px">
                        <v-icon style="font-size: 16px; line-height: 2; position: absolute; top: 6px;" slot="activator">info</v-icon>
                        <v-card>
                            <v-card-title>
                                <span class="headline">Max Avatar Info</span>
                            </v-card-title>
                            <v-card-text>
                                {{maxAvatarInfoTxt}}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green white--text" text @click="maxAvatarInfoDialog = false">
                                    Ok
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>-->
                </h3>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout wrap v-if="chatbotIcons.length > 0">
            <v-flex xs12 >
                <ul class="card-list">
                    <li v-for="(icon, index) in chatbotIcons" :key="index">
                        <div class="cardicon">
                            <v-card>
                                <v-menu offset-y v-if="icon.avatar_uploaded && icon.avatar_url != ''">
                                    <v-icon class="more_ic " slot="activator">more_vert</v-icon>
                                    <v-list>
                                        <v-list-tile v-for="(action, actionIndex) in maxAvatarActions" :key="actionIndex" @click="">
                                            <v-list-tile-title @click="moreActions(action.action,icon)">{{ action.title }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                                <template v-if="icon.avatar_uploaded && icon.avatar_url != ''">
                                    <v-avatar tile class="profile custom-div-mt12">
                                        <img :src="icon.avatar_url" :alt="icon.week_day_name">
                                    </v-avatar>
                                </template>
                                <template v-else>
                                    <div class="customImgWrap">
                                        <v-icon class="main_ic customIconWrap"> fa-arrow-circle-up </v-icon>
                                        <input type="file" class="custom-file-input inputfilebutton" @change="uploadMaxAvtar($event.target.files,icon)">
                                    </div>
                                </template>
                                <v-icon v-if="icon.avatar_uploaded && icon.avatar_url != ''" class="status_ic" color="green">check_circle</v-icon>
                                <v-icon v-else class="status_ic" color="red">cancel</v-icon>
                            </v-card>
                            <h3 class="uppercase">{{icon.week_day_name}}</h3>
                            <v-tooltip top>
                                <span slot="activator"> {{icon.avatar_name == '' ? needToUploadTxt : icon.avatar_name}}</span>
                                <span>{{ icon.avatar_name == '' ? needToUploadTxt : icon.avatar_name}}</span>
                            </v-tooltip>                            
                        </div>   
                    </li>
                </ul>             
            </v-flex>                     
        </v-layout>
    </v-container>
</div>
</template>
<script>
import API from "@/api";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import axios from "axios";
import config from "../../config";
import utils from "../../util";
import services from "../../services/HttpService";
import GoogleAds from "@/pages/widgets/GoogleAds";
import UploadButton from 'vuetify-upload-button';
export default {
    components: {
        VWidget,
        GoogleAds,
        'upload-btn': UploadButton
    },
    computed: {
    },
    data() {
        return {
            maxAvatarInfoTxt: config.maxAvatarInfoTxt,
            maxAvatarInfoDialog: false,
            chatbotIcons:[],
            maxAvatarActions: [
                {
                    title: 'Delete',
                    action:'delete',
                },
                {
                    title: 'Select New Image',
                    action:'newImage',
                }
            ],
            needToUploadTxt: config.needToUploadTxt,
            deleteModal: false,
            deleteIconObject: {},
            allowFileExtDoc : [ 'jpg', 'jpeg', 'png'],
            selectNewAvatarModal: false,
            changeIconObject: {},
            fileObj: {}
        }
    },
    mounted() {
    },
    created() {
        const self = this;
        self.getMaxAvatarList();
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        getMaxAvatarList(){
            const self = this,
            wApp = window.getApp;
            self.utils = utils;    
            wApp.$emit("showLoader", {
                show: true
            });
            axios.all([
                services.get("chatbot-avatars/list", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                })
            ])
            .then(axios.spread(function (result) {
                wApp.$emit("showLoader", {
                    show: false
                });
                if(result.data.data && result.data.data.length > 0){
                    self.chatbotIcons = result.data.data;
                }else{
                    self._showToast(result.data.message, config.errMsgColorStr);
                }
            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        uploadMaxAvtar(file, iconObject) {
            const self = this,wApp = window.getApp;
            let fileExtension = file[0].name.split('.').pop();
            if(file[0].size >= 2000000){
                self._showToast(config.maxAvatarFileSizeValidationMsg, config.errMsgColorStr);
                return false;
            } else if(!self.allowFileExtDoc.includes(fileExtension.toLowerCase())){
                self._showToast(config.maxAvatarFileTypeValidationMsg, config.errMsgColorStr);
                return false;
            } else {
                wApp.$emit("showLoader", {
                    show: true
                });
                let filesObj = new FormData();
                filesObj.append("week_day_name",iconObject["week_day_name"]);
                filesObj.append("week_day_number",iconObject["week_day_number"]);
                filesObj.append("uuid",iconObject["uuid"]);
                filesObj.append("file", file[0]);
                if(iconObject["avatar_name"] != ''){
                    filesObj.append("avatar_delete_url", config.chatbotAvatrsStorageFolderName+"/"+iconObject["avatar_name"]);
                }else{
                    filesObj.append("avatar_delete_url", "");
                }
                services.postFile("chatbot-avatars/upload-avatar", filesObj, {
                    'content-type': 'multipart/form-data',
                    "Authorization": "Bearer " + self.$store.state.user.token
                })
                .then(res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    if (res.data.status) {
                        self._showToast(res.data.message,config.successMsgColorStr);
                        self.getMaxAvatarList();
                    } else {
                        self._showToast(res.data.message, config.errMsgColorStr);
                    }
                    self.selectNewAvatarModal = false;
                    self.changeIconObject = {};
                    self.fileObj = {};
                    window.location.reload();
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, config.errMsgColorStr);
                    self.selectNewAvatarModal = false;
                    self.changeIconObject = {};
                    self.fileObj = {};
                    window.location.reload();
                });
            }
        },
        showDeleteModal(){
            const self = this;
            self.deleteModal = true;            
        },
        showAvatarModal(){
            const self = this;
            self.selectNewAvatarModal = true;
        },
        deleteAvatar(){
            const self = this,
            wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            let deleteReqObject = {
                "uuid":self.deleteIconObject.uuid,
                "avatar_url":config.chatbotAvatrsStorageFolderName+'/'+self.deleteIconObject.avatar_name
            }
            services.delete("chatbot-avatars/delete-avatar", deleteReqObject, {
                'content-type': 'multipart/form-data',
                "Authorization": "Bearer " + self.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self.deleteModal = false;
                self.deleteIconObject = {};
                self._showToast(res.data.message);
                self.getMaxAvatarList();
                window.location.reload();
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self.deleteModal = false;
                self.deleteIconObject = {};
                self._showToast(err.response.data.message, config.errMsgColorStr);
                window.location.reload();
            });
        },
        moreActions(action,iconObject){
            const self = this,
            wApp = window.getApp;
            self.fileObj = {};
            if(action == 'newImage'){
                self.changeImageAction = action;
                self.changeIconObject = iconObject;
                self.showAvatarModal();
            } else if(action == 'delete'){
                self.deleteAction = action;
                self.deleteIconObject = iconObject;
                self.showDeleteModal();                
            } 
        },
        onFileChange(file) {
            const self = this;
            self.fileObj = {};
            if(file.length > 0){
                self.fileValidations(file,function(res){
                    if(res){
                        self.fileObj = file;
                        self.uploadMaxAvtar(file,self.changeIconObject);
                    }
                });
            }
        },
        fileValidations(file, cb){
            const self = this;
            let fileExtension = file[0].name.split('.').pop();
            if(file[0].size >= 2000000){
                self._showToast(config.maxAvatarFileSizeValidationMsg,config.errMsgColorStr);
                cb(false);
            } else if(!self.allowFileExtDoc.includes(fileExtension.toLowerCase())){
                self._showToast(config.maxAvatarFileTypeValidationMsg, config.errMsgColorStr);
                cb(false);
            } else {
                cb(true);
            }            
        }
    }
};
</script>
<style lang="stylus">
.custom_table th,.custom_table td
  padding: 5px;
.v-input--selection-controls__ripple, .v-input--selection-controls__input
  height:auto;
  width:auto;
.v-input--selection-controls
    margin-top: 0px; 
#labeluploadFile.v-btn--active:before, #labeluploadFile.v-btn:hover:before, #labeluploadFile.v-btn:focus:before
  background:none;
  cursor: pointer;
.upload-btn .v-btn
    padding: 0px
    max-height: 56px;
    min-height: 56px;
.inputfilebutton
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    cursor: pointer;
    left: 0;
    top: 0;
.fileIconInput
    width: 100%;
    text-align: center;
.v-btn.remove-border {
    border: none !important;
}
h3.uppercase{
    text-transform : uppercase !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/chatbot/List.vue